<template>
<div class="page">
    <div class="user">
        <img src="@/assets/youxi@3x.png" alt="">
        <div class="login">望远网络</div>
    </div>
    <div class="flex">
        <div class="h5-fl"  @click="selectOrder()">
            <div class="h5-item">我的订单</div>
            <van-icon name="arrow" />
        </div>
        <!-- <br/>
        <div class="h5-fl" @click="toKefu()">
            <div class="h5-item">联系客服</div>
            <van-icon name="arrow" />
        </div> -->
        <br/>
        <div class="h5-fl"  @click="toLogin()">
            <div class="h5-item">注册登录</div>
            <van-icon name="arrow" />
        </div>
        <br/>
        <div class="h5-fl"  @click="toOut()">
            <div class="h5-item">注销信息</div>
            <van-icon name="arrow" />
        </div>
        <!-- <br/>
        <div class="h5-fl" @click="toGuanzhu()">
            <div class="h5-item">关注公众号</div>
            <van-icon name="arrow" />
        </div> -->
    </div>
    <div class="copyRight">
        <div style="text-align: center;margin-bottom:14px;">电话：0755-61678977</div>
        <div style="text-align: center;margin:14px 0;">海南流量助手信息技术有限公司</div>
        <div style="text-align: center;margin-bottom:14px;">地址：海南省海口市国家高新技术产业开发区南海大道266号创业孵化中心A楼5层A29-698室</div>
    </div>
    <van-tabbar v-model="active" @change="onChange">
        <van-tabbar-item icon="home-o">首页</van-tabbar-item>
        <van-tabbar-item icon="friends-o">我的</van-tabbar-item>
    </van-tabbar>


    <van-dialog v-model="guanzhuImg" style="color:red" title="更多资讯,请关注公众号" show-cancel-button>
			<img style="width:100%;" src="@/assets/mifi/kefu5.png" />
		</van-dialog>


</div>
</template>
<script>
import { Toast } from 'vant'
export default{
    data(){
        return{
            guanzhuImg:false,
            active:1,
            userPhone:''
        }
    },
    methods:{
        toOut(){
            Toast.success('注销成功')
            localStorage.removeItem('myLoginPhone')
        },
        toLogin(){
            this.$router.push({ path: '/user/miBindPhone'});
        },
        toGuanzhu(){
            this.guanzhuImg=true;
        },
        selectOrder(){
            this.$router.push({ path: '/user/buyShebeiSelect'});
        },
        toOrder(){

        },
        toKefu(){
            window.location.href='http://kefu.szxxtx.com/s/119480bqis';
        },
        onChange(data){
            if(data === 0){
                this.$router.push({ path: '/user/buyShebei'});
            }
        },
    }
}
</script>
<style lang="less" scoped>
.page{
    background:#f3f3f3;
    height:100%;
    position: relative;
}
.user{
    height:150px;
    background: #3d68f8;
    text-align: center;
    img{
        width:50px;
        height:50px;
        border-radius:100%;
        margin: 30px 0 20px 0;
    }
    .login{
        text-align: center;
        color:#fff;
    }
}
.flex{
    margin:10px;
    background:#fff;
    padding:10px;
    .h5-fl{
        display: flex;
        align-items: center;
        height:40px;
        &:first-child{
            border-bottom:1px solid #f4f4f4;
        }
        .h5-item{
            flex: 1;
        }
        .van-icon{
            width:14px;
        }
    }
}
.copyRight{
    position: absolute;
    bottom:50px;
    left: 0;
    right:0;
    margin: auto;
}
</style>